export function onToggleWidget() {
    return {
        type: "IS_OPEN",
        payload: false
    }
}

export function onMessage(message) {
    return {
        type: message.type,
        payload: message.payload
    }
}

export function onGetEventFeedback(event) {
    return {
        type: "EVENT_FEEDBACK",
        payload: event
    }
}

export function onAddMark(mark) {
    return {
        type: "ADD_MARK",
        payload: mark
    }
}

export function onSend(message) {
    return {
        type: message.type,
        payload: message.payload
    }
}

export function onSetHistory(history) {
    return {
        type: "SET_HISTORY",
        payload: history
    }
}

export function onChangeResizeCarousel(payload) {
    return {
        type: "CHANGE_RESIZE_CAROUSEL",
        payload
    }
}

export function onMenuReceiver(payload) {
    return {
        type: "MENU_RECEIVER",
        payload
    }
}

export function onMenuReceiverHide(payload) {
    return {
        type: "MENU_SENDER",
        payload
    }
}

export function onBackupWithRoomExpired(payload) {
    return {
        type: "ROOM_EXPIRED_BACKUP",
        payload
    }
}

export function onBackupHistoryMessages(payload) {
    return async dispatch => await dispatch({type: "BACKUP_HISTORY_MESSAGES", payload});
}



// WEBPACK FOOTER //
// ./src/redux/actions.js